import { BookOpen, Timer, Mic, Brain, Activity } from 'lucide-react';
import { formatDistanceToNow } from 'date-fns';
import { tr as dateFnsTr, enUS } from 'date-fns/locale';
import { useLanguage } from '../../contexts/LanguageContext';

const ICON_MAP = {
  BookOpen,
  Timer,
  Mic,
  Brain,
};

export default function RecentActivityFeed({ activities = [] }) {
  const { t, lang } = useLanguage();
  const locale = lang === 'tr' ? dateFnsTr : enUS;

  return (
    <div className="bg-white rounded-2xl border-2 border-gray-200 shadow-[0_4px_0_0_#E5E5E5] p-4">
      <div className="flex items-center gap-2 mb-3">
        <Activity size={18} className="text-[var(--brand-primary)]" aria-hidden="true" strokeWidth={2.5} />
        <h3 className="text-sm font-bold text-[var(--text-main)]">
          {t('cabin.activity.title')}
        </h3>
      </div>

      {activities.length === 0 ? (
        <p className="text-xs text-[var(--text-muted)] text-center py-4">—</p>
      ) : (
        <ul className="flex flex-col gap-2" role="list">
          {activities.slice(0, 5).map((item) => {
            const Icon = ICON_MAP[item.icon] || BookOpen;
            const title = lang === 'tr' ? item.title_tr : item.title_en;
            const timeAgo = formatDistanceToNow(new Date(item.timestamp), {
              locale,
              addSuffix: true,
            });

            return (
              <li
                key={item.id}
                className="flex items-center gap-3 py-1.5 border-b border-gray-100 last:border-0"
              >
                <div className="shrink-0 w-8 h-8 bg-sky-50 rounded-lg flex items-center justify-center">
                  <Icon size={16} className="text-[var(--brand-primary)]" aria-hidden="true" />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-xs font-semibold text-[var(--text-main)] truncate">{title}</p>
                  <p className="text-xs text-[var(--text-muted)]">{timeAgo}</p>
                </div>
                <span className="shrink-0 text-xs font-bold text-[var(--brand-success)]">
                  +{item.miles}
                </span>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
